import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import Dashboard from './Dashboard';
import ViewPatientData from './ViewPatientData';
import ErrorBoundary from '../../ErrorBoundary';


class JeevaSessionTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            projectId: null,
            hideBotStore: false,
            patientAdmissionHeading: ''
        }
        window.admissionsNavBarController = this;
    }

    componentDidMount() {

        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#jeeva-sessions,#view-patient-data")
                .on("click", function () {
                    $("#jeeva-sessions,#dview-patient-data")
                        .removeClass('active');
                    localStorage.setItem("dashboard-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();

    }

    markActiveTab() {
        $("#jeeva-sessions,#view-patient-data").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("dashboard-nav-bar-selection");
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/reports/jeeva-sessions') || currentPath.includes('/projectmgmt/reports/jeeva-sessions/')) {
            defaultSelection = "jeeva-sessions";
        } else if (currentPath.includes('/projectmgmt/reports/view-patient-data') || currentPath.includes('/projectmgmt/reports/view-patient-data/')) {
            defaultSelection = "view-patient-data";
        }
        if (defaultSelection !== false) {
            $("#patientDashBoardMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("dashboard-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#patientDashBoardMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }

    render() {
        this.markActiveTab();
        return (
            <ErrorBoundary>
            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" >
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster" id="patientDashBoardMenu">
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/reports/jeeva-sessions" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="jeeva-sessions" style={{ marginRight: '15px' }}>
                                        Jeeva's Sessions
                                    </li></Link>

                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/reports/view-patient-data" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="view-patient-data" style={{ marginRight: '15px' }}>
                                        View Episode Data
                                    </li></Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/jeeva-sessions" component={Dashboard}></Route>
                    <Route path="/projectmgmt/reports/view-patient-data" component={ViewPatientData}></Route>
                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}
export default JeevaSessionTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JeevaSessionTabSettings.js